import React from "react";
import {
  NativeSyntheticEvent,
  TextInput,
  TextInputKeyPressEventData,
  View,
} from "react-native";

import Icon from "react-icons-kit";
import { ic_search } from "react-icons-kit/md/ic_search";
import { styles } from "UpduoLibrary";

import { upduoMediumDarkGray } from "config/UpduoColors";

interface SearchBarProps {
  placeholder?: string;
  placeholderTextColor?: string;
  searchIconColor?: string;
  searchIconSize?: number;
  onChangeText?: (text: string) => void;
  onFocus?: ({ nativeEvent }) => void;
  onBlur?: () => void;
  onKeyPress?: (e: NativeSyntheticEvent<TextInputKeyPressEventData>) => void;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

export default function SearchBar({
  placeholder,
  placeholderTextColor,
  searchIconColor = upduoMediumDarkGray,
  searchIconSize = 22,
  onChangeText,
  onFocus,
  onBlur,
  onKeyPress,
  onClick,
}: SearchBarProps) {
  return (
    <View>
      <TextInput
        style={styles.searchInput}
        placeholder={placeholder}
        placeholderTextColor={placeholderTextColor}
        onChangeText={onChangeText}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
      />
      <View style={{ position: "absolute", top: 5, left: 10 }}>
        <div style={{ color: searchIconColor }} onClick={onClick}>
          <Icon size={searchIconSize} icon={ic_search} />
        </div>
      </View>
    </View>
  );
}
